import React, { useEffect, useRef, useState } from "react";
import classes from "./style.module.scss";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import { Controller, FormProvider, useForm } from "react-hook-form";
import InputBox from "../../component/InputBox";
import FileUpload from "../../component/FileUpload";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import { singleUpload } from "../../helpers";
import GetUserPermission from "../../component/GetUserPermission";
import { useNavigate } from "react-router-dom";
import { KG_BEARINGS, KG_BULK_FILTRATION, KG_FILTERS, KG_PROMO, KG_TRUCK_SOLUTIONS } from '../../helpers';

const statusOptions = [
  { label: KG_FILTERS, value: 3 },
  { label: KG_TRUCK_SOLUTIONS, value: 4 },
  { label: KG_BEARINGS, value: 1 },
  { label: KG_BULK_FILTRATION, value: 2 },
];

const EditUserModal = (props) => {
  const {
    isOpen = false,
    closePopUp,
    activeTab,
    resourceId,
    handleSuccessModal,
  } = props;
  const selectBoxRef = useRef();
  const Phone = "Phone";
  const Email = "Email";
  const WhatsApp = "WhatsApp";
  const contactOptions = [
    { label: Phone, value: 1 },
    { label: Email, value: 2 },
    { label: WhatsApp, value: 3 },
  ];
  const storeOwnerOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 2 },
  ]
  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    trigger,
  } = formMethods;

  const [fileName, setFileName] = useState(null);
  const [fileName1, setFileName1] = useState(null);
  const [fileName2, setFileName2] = useState(null);
  const [pictureName, setPictureName] = useState(null);
  const [pictureName1, setPictureName1] = useState(null);
  const [pictureName2, setPictureName2] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [uploadedFiles1, setUploadedFiles1] = useState(null);
  const [uploadedFiles2, setUploadedFiles2] = useState(null);
  const [uploadedPicture, setUploadedPicture] = useState(null);
  const [uploadedPicture1, setUploadedPicture1] = useState(null);
  const [uploadedPicture2, setUploadedPicture2] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const addPermission = GetUserPermission({ key: 'add', microAppPath: 'rewards' });
  const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'rewards' });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isEdit) {
      if (!editPermission) {
        closePopUp()
        redirectBack()
      }
    } else {
      if (!addPermission) {
        closePopUp()
        redirectBack()
      }
    }
  }, [isEdit])

  useEffect(() => {
    if (resourceId) {
      getDetails(resourceId);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [resourceId]);

  const redirectBack = () => {
    navigate('')
  }

  const getDetails = async (id) => {
    let url = `${Exported.Endpoints.getUserDetails}`;
    let paramsObj = {
      user_id: id,
    };
    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data?.userInfo;
          console.log(detailInfo)
         if (detailInfo?.identity?.documents[0]) {
            setValue("uploadIdentity", detailInfo.identity.documents[0]);
            setFileName([detailInfo?.identity?.documents[0]] || null);
         }
         if (detailInfo?.identity?.documents[1]) {
            setValue("uploadIdentity1", detailInfo.identity.documents[1]);
            setFileName1([detailInfo?.identity?.documents[1]] || null);
         }
         if (detailInfo?.identity?.documents[2]) {
            setValue("uploadIdentity2", detailInfo.identity.documents[2]);
            setFileName2([detailInfo?.identity?.documents[2]] || null);
         }
         if (detailInfo?.facilityPhotos?.documents[0]) {
            setValue("uploadFacility", detailInfo.facilityPhotos.documents[0]);
            setPictureName([detailInfo?.facilityPhotos?.documents[0]] || null);
         }
         if (detailInfo?.facilityPhotos?.documents[1]) {
            setValue("uploadFacility1", detailInfo.facilityPhotos.documents[1]);
            setPictureName1([detailInfo?.facilityPhotos?.documents[1]] || null);
         }
         if (detailInfo?.facilityPhotos?.documents[2]) {
            setValue("uploadFacility2", detailInfo.facilityPhotos.documents[2]);
            setPictureName2([detailInfo?.facilityPhotos?.documents[2]] || null);
         }
         setValue("legal_name", detailInfo?.businessInfo?.legal_name || null);
         setValue("mobile_number", detailInfo?.businessInfo?.mobile_number);
         setValue("email", detailInfo?.businessInfo?.email);
         setValue("website_url", detailInfo?.businessInfo?.website_url || null);
         setValue("business_address", detailInfo?.businessInfo?.business_address || null);
         setValue("mailing_address", detailInfo?.contactInfo?.mailing_address || null);
         setValue("contact_method", detailInfo?.contactInfo?.contact_method);
         setValue("store_owner", detailInfo?.contactInfo?.store_owner);
          // setFileName([detailInfo?.identity?.documents[0]] || null);
          // setPictureName([detailInfo?.facilityPhotos?.documents[0]] || null);
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const onSubmit = async (data) => {
    console.log(data, "data");
    trigger();
    dispatch(saveLoadingState(true));
    let uploadedObj = {};
    let uploadedObj1 = {};
    let uploadedObj2 = {};
    let uploadedPicObj = {};
    let uploadedPicObj1 = {};
    let uploadedPicObj2 = {};
    if (uploadedFiles && uploadedFiles.length > 0) {
      uploadedObj = await singleUpload(uploadedFiles);
    }
    if (uploadedFiles1 && uploadedFiles1.length > 0) {
      uploadedObj1 = await singleUpload(uploadedFiles1);
    }
    if (uploadedFiles2 && uploadedFiles2.length > 0) {
      uploadedObj2 = await singleUpload(uploadedFiles2);
    }
    if (uploadedPicture && uploadedPicture.length > 0) {
      uploadedPicObj = await singleUpload(uploadedPicture);
    }
    if (uploadedPicture1 && uploadedPicture1.length > 0) {
      uploadedPicObj1 = await singleUpload(uploadedPicture1);
    }
    if (uploadedPicture2 && uploadedPicture2.length > 0) {
      uploadedPicObj2 = await singleUpload(uploadedPicture2);
    }
    let url = `${Exported.Endpoints.updateUser}`;
    let requestData = {
      user_id: resourceId,
      identity: {
        documents: [],
      },
      facilityPhotos: {
        documents: [],
      },
      businessInfo: {
        legal_name: data?.legal_name,
        mobile_number: data?.mobile_number,
        email: data?.email,
        website_url: data?.website_url,
        business_address: data?.business_address,
      },
      contactInfo: {
        mailing_address: data?.mailing_address,
        contact_method: data?.contact_method,
        store_owner: data?.store_owner,
      },
    };
   
    if (uploadedObj?.url) {
      requestData.identity.documents.push(uploadedObj.url);
    }
    if (uploadedObj1?.url) {
      requestData.identity.documents.push(uploadedObj1.url);
    }
    if (uploadedObj2?.url) {
      requestData.identity.documents.push(uploadedObj2.url);
    }
    
    if (uploadedPicObj?.url) {
      requestData.facilityPhotos.documents.push(uploadedPicObj.url);
    }
    if (uploadedPicObj1?.url) {
      requestData.facilityPhotos.documents.push(uploadedPicObj1.url);
    }
    if (uploadedPicObj2?.url) {
      requestData.facilityPhotos.documents.push(uploadedPicObj2.url);
    }

    // If no new files uploaded, keep existing files from form data
    if (!uploadedObj?.url && data?.uploadIdentity) {
      requestData.identity.documents.push(data.uploadIdentity);
    }
    if (!uploadedObj1?.url && data?.uploadIdentity1) {
      requestData.identity.documents.push(data.uploadIdentity1);
    }
    if (!uploadedObj2?.url && data?.uploadIdentity2) {
      requestData.identity.documents.push(data.uploadIdentity2);
    }
    if (!uploadedPicObj?.url && data?.uploadFacility) {
      requestData.facilityPhotos.documents.push(data.uploadFacility);
    }
    if (!uploadedPicObj1?.url && data?.uploadFacility1) {
      requestData.facilityPhotos.documents.push(data.uploadFacility1);
    }
    if (!uploadedPicObj2?.url && data?.uploadFacility2) {
      requestData.facilityPhotos.documents.push(data.uploadFacility2);
    }


    await request({
      url: url,
      method: Exported.APIMethods.PUT,
      data: requestData,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          closePopUp();
          Toast({
            type: "success",
            message: "User Edited Successfully",
          });
          handleSuccessModal();
        }
      })
      .catch((err) => {
        console.log(err, "err");
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    dispatch(saveLoadingState(false));
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.resourcesUploadWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>Update User</div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                {activeTab !== "Completed Mechanic" && activeTab !== "Incomplete Mechanic" ? (
                  <>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadIdentity"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadIdentity}
                    messages={{
                      required: "Identity file is required",
                    }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="video/mp4, video/avi, video/mkv, video/mov, video/wmv, video/flv, application/pdf"
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Identity File 1 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadIdentity1"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    // setError={formMethods.setError}
                    // error={errors.uploadIdentity}
                    // messages={{
                    //   required: "Identity file is required",
                    // }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="video/mp4, video/avi, video/mkv, video/mov, video/wmv, video/flv, application/pdf"
                    fileNames={fileName1}
                    setFileName={setFileName1}
                    uploadedFiles={uploadedFiles1}
                    setUploadedFiles={setUploadedFiles1}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Identity File 2 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadIdentity2"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    // setError={formMethods.setError}
                    // error={errors.uploadIdentity}
                    // messages={{
                    //   required: "Identity file is required",
                    // }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="video/mp4, video/avi, video/mkv, video/mov, video/wmv, video/flv, application/pdf"
                    fileNames={fileName2}
                    setFileName={setFileName2}
                    uploadedFiles={uploadedFiles2}
                    setUploadedFiles={setUploadedFiles2}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Identity File 3 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadFacility"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadFacility}
                    messages={{
                      required: "Facility Photo is required",
                    }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="image/png, image/jpg, image/jpeg"
                    fileNames={pictureName}
                    setFileName={setPictureName}
                    uploadedFiles={uploadedPicture}
                    setUploadedFiles={setUploadedPicture}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Facility Photo 1 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadFacility1"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadFacility}
                    messages={{
                      required: "Facility Photo is required",
                    }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="image/png, image/jpg, image/jpeg"
                    fileNames={pictureName1}
                    setFileName={setPictureName1}
                    uploadedFiles={uploadedPicture1}
                    setUploadedFiles={setUploadedPicture1}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Facility Photo 2 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <FileUpload
                    name="uploadFacility2"
                    className={`p-4 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadFacility}
                    messages={{
                      required: "Facility Photo is required",
                    }}
                    maxSize={20971520}
                    maxLable="20MB"
                    label="Upload File"
                    acceptFiles="image/png, image/jpg, image/jpeg"
                    fileNames={pictureName2}
                    setFileName={setPictureName2}
                    uploadedFiles={uploadedPicture2}
                    setUploadedFiles={setUploadedPicture2}
                    isFileUploading={isFileUploading}
                    placeholder="Upload Facility Photo 3 (Max: 20 MB)"
                    // multiple={true}
                  />
                </div>
                </>
                ) : ""}
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Legal Name"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"legal_name"}
                    {...register("legal_name", {
                      required: true,
                    })}
                    placeholder={"Legal Name"}
                    error={errors.legal_name}
                    messages={{
                      required: "Legal Name is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                {/* <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Mobile Number"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"mobile_number"}
                    {...register("mobile_number", {
                      required: true,
                    })}
                    placeholder={"Mobile Number"}
                    error={errors.mobile_number}
                    messages={{
                      required: "Mobile Number is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Email"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"email"}
                    {...register("email", {
                      required: true,
                    })}
                    placeholder={"Email"}
                    error={errors.email}
                    messages={{
                      required: "Email is required",
                    }}
                    isEdit={isEdit}
                  />
                </div> */}
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Website URL"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"website_url"}
                    {...register("website_url", {
                      // required: true,
                    })}
                    placeholder={"Website URL"}
                    error={errors.website_url}
                    messages={{
                      // required: "Website URL is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Business Address"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"business_address"}
                    {...register("business_address", {
                      required: true,
                    })}
                    placeholder={"Business Address"}
                    error={errors.business_address}
                    messages={{
                      required: "Business Address is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Mailing Address"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"mailing_address"}
                    {...register("mailing_address", {
                      required: true,
                    })}
                    placeholder={"Mailing Address"}
                    error={errors.mailing_address}
                    messages={{
                      required: "Mailing Address is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="contact_method"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Contact Method"
                        placeholder="Contact Method"
                        list={contactOptions}
                        isEdit={isEdit}
                        {...field}
                        error={errors.contact_method}
                        messages={{
                          required: "Contact Method is required",
                        }}
                      />
                    )}
                  />
                </div>
                {activeTab !== "Completed Mechanic" && activeTab !== "Incomplete Mechanic" ? (
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="store_owner"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Store Owner"
                        placeholder="Store Owner"
                        list={storeOwnerOptions}
                        isEdit={isEdit}
                        {...field}
                        error={errors.store_owner}
                        messages={{
                          required: "Store Owner is required",
                        }}
                      />
                    )}
                  />
                </div>
                ) :""}
                {/* <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Description"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"description"}
                    type={"textarea"}
                    {...register("description", {
                      required: true,
                    })}
                    placeholder={"Description"}
                    error={errors.description}
                    messages={{
                      required: "Description is required",
                    }}
                    isEdit={isEdit}
                  />
                </div> */}
                <div className="flex justify-end">
                  <Button
                    text={"Update"}
                    className={`w-[100%] my-4`}
                    smallBtn
                  />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default EditUserModal;
